import { checkoutUser } from "../services/userActivities";
import firebase from "../services/firebase";
import { clearMfaSession } from "./mfaSession";

export const getUserActivityInfoFromStorage = () => {
  const userActivityId = localStorage.getItem("userActivityId");
  const userActivitySessionId = sessionStorage.getItem("userActivitySessionId");

  return { userActivityId, userActivitySessionId };
};

export const setUserActivityInfoFromStorage = (userActivityId, userActivitySessionId) => {
  localStorage.setItem("userActivityId", userActivityId);
  sessionStorage.setItem("userActivitySessionId", userActivitySessionId);
};

export const removeUserActivityInfoFromStorage = () => {
  localStorage.removeItem("userActivityId");
  sessionStorage.removeItem("userActivitySessionId");
};

export const signOut = async () => {
  const { userActivityId } = getUserActivityInfoFromStorage();
  await checkoutUser(userActivityId);
  removeUserActivityInfoFromStorage();
  clearMfaSession();
  firebase.signOut();
};
